module.exports = __webpack_public_path__ + "static/DS_housewarming-1b727e55ff2b0617fa2a6f3b458003f5.jpg";